import Component from '../core/Component'
import EventBus from '../core/EventBus'

export default class StoreList extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            blockReveal: null
        }
    }

    prepare() {
        EventBus.on('marker:click', this.handleMarkerClick)
    }

    destroy() {
        EventBus.off('marker:click', this.handleMarkerClick)
    }

    handleMarkerClick = ({ point }) => {
        const blockReveal = Component.getFromElement(this.ref.blockReveal)

        if (blockReveal) {
            blockReveal.show(point.url)
        }
    }
}